<template>
  <li ref="flyoutMenuRef" class="relative">
    <button
      type="button"
      class="appearance-none bg-transparent flex items-center hover_text-gray-600"
      @click="isMenuShowing = !isMenuShowing"
    >
      <slot name="button">
        {{ title }}
        <ChevronDownIcon class="w-6" />
      </slot>
    </button>
    <menu
      class="absolute top-8 my-3.5 z-50 transform opacity-0 translate-y-0 transition-all bg-white rounded-lg shadow-lg ring-1 ring-gray-200 duration-75"
      :class="[menuClass, { invisible: !isMenuShowing, 'opacity-100': isMenuShowing, 'translate-y-1': !isMenuShowing }]"
      @click="isMenuShowing = !isMenuShowing"
    >
      <slot />
    </menu>
  </li>
</template>

<script lang="ts" setup>
import { ChevronDownIcon } from '@heroicons/vue/20/solid'

defineProps({
  title: {
    type: String,
    default: '',
  },
  menuClass: {
    type: String,
    default: '',
  },
})

const flyoutMenuRef = ref(null)
const isMenuShowing = ref(false)

function closeOnClickAway(e: MouseEvent) {
  if (e.target !== flyoutMenuRef.value && !(flyoutMenuRef.value as any)?.contains(e.target)) {
    isMenuShowing.value = false
  }
}

onMounted(async () => {
  document.addEventListener('click', closeOnClickAway)
})

onBeforeUnmount(() => {
  document.removeEventListener('click', closeOnClickAway)
})
</script>
